/*
 * @Author: Teemo Ding
 * @Date: 2021-11-16 11:39:06
 * @LastEditTime: 2023-02-06 08:55:02
 * @LastEditors: Please set LastEditors
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/Refund/Components/ReturnDetails/index.tsx
 */

import Configuration from '@/src/components/Configuration/Configuration';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import UploadModal from '@/src/components/Upload/UploadModal';
import { useRequest } from 'ahooks';
import { Form } from 'antd';
import { cloneDeep, get } from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import {
  Image,
  Input,
  Label,
  ModalFooter,
  SizeFittingTable,
  TextArea,
} from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import AntdImageDisplay from 'src/components/Upload/ImageDisplay/AntdImageDisplay';
import {
  confirmLogistics,
  confirmReturnRequest,
} from 'src/request/order/refund';
import { accMul } from 'src/tools/math';
import { EnumTablePosition } from 'src/types/common/common';
import { EOrderReturnsStatus, EType } from 'src/types/common/order';
import ExclusiveCustom from '../../../../../Components/ExclusiveCustom';
import SkuItems from '../../../../../Components/SkuItems';

import { UploaderPlaceholder } from '@/src/components/Upload/Uploader';
import { EOperationType } from '@/src/types/common/order';
import { TableNumberInputWithSlash } from 'src/components/EditableTable/TableForm1';
import { ParentQty } from '../../../ReadyToPick';
import { EExternalRef } from '../../../tools';

import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet } from '@/src/tools/tools';
import css from './css.module.less';

const tableName = 'returnDetail';
const formName = 'returnDetailForm';
const widthDict = {
  item: { minWidth: 195 },
  sku: { minWidth: 118 },
  qty: {
    width: 97,
  },
  tax: { width: 96 },
  paid: { width: 90 },
};

const RenderUploader = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { value = [], onChange, disabled } = props;
  const [visible, setVisible] = useState(false);
  return (
    <div className={css.uploader}>
      {(value || []).map((i, index) => {
        const { url } = i;
        return (
          <AntdImageDisplay
            {...(!disabled
              ? {
                  onRemove: () => {
                    const _images = [...value];
                    _images.splice(index, 1);
                    onChange(_images);
                  },
                }
              : {})}
            {...(disabled ? { hideRemove: true } : {})}
            hasOptionsLayer
            style={{ marginRight: 16 }}
            width={141}
            height={141}
            key={url}
            src={url}
            alt={url}
          />
        );
      })}
      {(value || []).length < 3 && !disabled && (
        <UploaderPlaceholder
          width={141}
          height={141}
          handleShowModal={() => setVisible(true)}
          description={getI18n(
            'allOrders.orderDetail.refund_components_returndetails_render_up_loader_UploaderPlaceholder_description',
          )}
          btnText={getI18n(
            'allOrders.orderDetail.refund_components_returndetails_render_up_loader_UploaderPlaceholder_btntext',
          )}
        />
      )}
      <UploadModal
        type='Image'
        visible={visible}
        onCancel={() => setVisible(false)}
        width={1080}
        onOk={(imgArr = []) => {
          const valueCopy = (value || []).concat(imgArr || []);
          if (onChange) {
            if (valueCopy.length >= 3) {
              const valueCopySlice = valueCopy.slice(0, 3);
              onChange(valueCopySlice);
            } else {
              onChange(valueCopy);
            }
            setVisible(false);
          }
        }}
      />
    </div>
  );
};

const ReturnDetails = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    onModalCancel,
    returnDetail,
    disabled, //只disabled上半部分
    onUpdate,
    orderUuid,
    viewDetail, //查看详情模式，disabled全部
    decimalPosition,
  } = props;
  const disabledTop = disabled || viewDetail;
  const {
    items: dataItem,
    remark = '',
    images = '',
    uuid: returnUuid = '',
    returnLogisticsInfo = {},
    status,
  } = returnDetail || {};
  const {
    courier = '',
    remark: logisticsRemark = '',
    waybillNo = '',
    images: logisticsImage = [],
  } = returnLogisticsInfo || {};
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [productDetail, setProductDetail] = useState(dataItem);
  const expandedRows = (productDetail || []).map((i) => i.uuid);

  const { run: runConfirmRequest } = useRequest(
    (data) => confirmReturnRequest(data),
    {
      manual: true,
      onSuccess(res) {
        onModalCancel();
        if (onUpdate) onUpdate(res);
      },
    },
  );
  const { run: runConfirmLogistics } = useRequest(
    (data) => confirmLogistics(data),
    {
      manual: true,
      onSuccess(res) {
        onModalCancel();
        if (onUpdate) onUpdate(res);
      },
    },
  );

  useEffect(() => {
    const checkedItems = dataItem
      .filter((o) => o.checked)
      .map((item) => item.uuid);
    setSelectedRowKeys(checkedItems);
    let refundItems = dataItem;
    if (disabledTop) {
      refundItems = dataItem.filter((o) => o.checked);
    }

    refundItems.forEach((item) => {
      item.refundAmount = item.amount;
    });
    setProductDetail(refundItems);
    form.setFieldsValue({
      remark: remark,
      images,
      courier: courier || '',
      waybillNo,
      logisticsRemark,
      logisticsImage,
    });
  }, []);

  const onQuantityChange = (refundAmount, index, uuid) => {
    const _readyToPickItems = cloneDeep(productDetail || []);
    (_readyToPickItems[index] || {}).refundAmount = refundAmount;
    setProductDetail(_readyToPickItems);
  };

  const columns = [
    {
      title: getI18n(
        'allOrders.orderDetail.refund_components_returndetails_columns_item_title',
      ),
      key: 'productName',
      dataIndex: 'productName',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { productName } = record;
        const thumbnailUrl = get(record, 'image.url');
        return (
          <div className={css.productNameContainer}>
            <Image
              style={{
                marginRight: 12,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />

            <NoWrapContainer>
              <GlobalTooltip title={productName || '-'}>
                <div className={css.text}>{productName || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
      ...widthDict['item'],
    },
    {
      title: 'SKU',
      key: 'SKU',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { sku } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={sku || '-'}>{sku}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['sku'],
    },
    {
      titleGenerate: () =>
        disabledTop ? (
          <span>QTY</span>
        ) : (
          <span>
            <EditIcon /> QTY
          </span>
        ),
      key: 'QTY',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record, index) => {
        // console.log('record', record);
        const { amount, refundAmount, uuid } = record;
        const isParent = record[EExternalRef.isParent];
        if (isParent) {
          return <ParentQty set={record} data={productDetail} />;
        }
        return disabledTop ? (
          refundAmount
        ) : (
          <TableNumberInputWithSlash
            itemProps={{
              min: 1,
              max: amount,
              onBlur: (e) => {
                onQuantityChange(e, index, uuid);
              },
              backPart: (
                <div className={css.suffixPart}>
                  /
                  <NoWrapContainer>
                    <GlobalTooltip title={amount}>
                      {amount || '-'}
                    </GlobalTooltip>
                  </NoWrapContainer>
                </div>
              ),
            }}
            value={refundAmount}
            label={
              refundAmount == amount ? amount : `${refundAmount || 0}/${amount}`
            }
          />
        );
      },
      ...widthDict['qty'],
    },
    {
      titleGenerate: () => (
        <div>
          <div>{getI18n('general.paidPrice')}.</div>
          <div>
            ({getI18n('general.excl')}. {getI18n('general.tax')})
          </div>
        </div>
      ),
      key: 'Paid',
      default: true,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        const { paidPrice, type, refundAmount } = record;
        if (type === EType.Gift) {
          return <span>Gift</span>;
        }
        const data = accMul(paidPrice || 0, refundAmount || 0).toFixed(
          decimalPosition,
        );
        // console.log(data, 'currency');
        return (
          <NoWrapContainer className={css.paidPrice}>
            <GlobalTooltip title={data}>{data || '-'}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['paid'],
    },
  ];

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const onFinish = (values) => {
    if (!disabledTop) {
      const _productDetail = cloneDeep(productDetail || []);
      const { remark, images } = values;
      _productDetail.forEach((item) => {
        if (selectedRowKeys.includes(item.uuid)) {
          item.checked = true;
          item.customisationChecked = true;
        }
      });
      runConfirmRequest({
        type: EOperationType.Return,
        orderUuid,
        items: _productDetail,
        remark,
        images,
        uuid: returnUuid,
      });
    } else {
      const {
        courier = '',
        waybillNo,
        logisticsRemark,
        logisticsImage,
      } = values;
      const returnLogisticsInfo = {
        courier,
        waybillNo,
        remark: logisticsRemark,
        images: logisticsImage || [],
      };
      runConfirmLogistics({
        ...returnDetail,
        returnLogisticsInfo,
        uuid: returnUuid,
      });
    }
  };
  return (
    <Fragment>
      <div className={css.returnDetails}>
        <h3 className={css.title}>Request Details</h3>
        <SizeFittingTable
          rowKey='uuid'
          pagination={false}
          dataSource={productDetail}
          className={css.detailTable}
          id={tableName}
          columns={columns}
          {...(!disabledTop ? { rowSelection: rowSelection } : {})}
          expandable={{
            expandedRowClassName: (record) => {
              const isParent = get(record, EExternalRef.isParent);
              const isChild = get(record, EExternalRef.isChild);
              const isLast = get(record, EExternalRef.isLast);
              //console.log(record);
              const shouldHideBottomLine = (isParent || isChild) && !isLast;
              return `${css.expandedRow} ${
                shouldHideBottomLine ? css.hideBottomLine : ''
              }`;
            },
            expandedRowRender: (record, expandedIndex) => {
              const isChild = get(record, EExternalRef.isChild);
              const customisationItem =
                get(record, 'customisation.items') || [];
              const skuItems = get(record, 'simpleProducts') || [];
              const optionValues = get(record, 'optionValues') || [];
              const exclusiveCustomData = (customisationItem || []).map(
                (item) => ({
                  title: `${item.title} : ${(item.values || []).join(',')}`,
                }),
              );
              const customisationPrice = get(record, 'customisationPrice', '');
              const skuItemsOptions = skuItems.map((item) => [
                item.productName,
                item.sku,
              ]);
              if (isChild) {
                return <React.Fragment />;
              }
              if (
                !customisationItem.length &&
                !skuItems.length &&
                !optionValues.length
              ) {
                return <React.Fragment />;
              }
              return (
                <React.Fragment>
                  <div className={css.optionValues}>
                    {optionValues.map((item, index) => (
                      <span key={index}>
                        {item.label}:{item.value},
                      </span>
                    ))}
                  </div>
                  <div className={css.customizationLine}>
                    <div className={css.skuItems}>
                      <SkuItems data={skuItemsOptions} />
                    </div>

                    {!!customisationItem.length && (
                      <div className={css.disabledCustom}>
                        <ExclusiveCustom data={exclusiveCustomData} />
                        {customisationPrice}
                      </div>
                    )}
                  </div>
                </React.Fragment>
              );
            },
            expandIconColumnIndex: -1,
            indentSize: 0,
            expandedRowKeys: expandedRows,
          }}
        />
        <Form name={formName} form={form} onFinish={onFinish}>
          <div className={disabledTop ? css.reasonWithLine : css.reason}>
            <Form.Item
              name='remark'
              rules={[
                {
                  required: true,
                  message: getI18n(
                    'allOrders.orderDetail.refund_components_returndetails_return_reason_formitem_rules_msg',
                  ),
                },
              ]}
              labelCol={{ span: 24 }}
              className={css.formItem}
              label={
                <Label
                  title={getI18n(
                    'allOrders.orderDetail.refund_components_returndetails_return_reason_formitem_rules_label',
                  )}
                />
              }>
              <TextArea
                disabled={disabledTop}
                autoSize={{ minRows: 6, maxRows: 6 }}
              />
            </Form.Item>
            <Form.Item
              labelCol={{ span: 24 }}
              name='images'
              className={css.formItem}
              label={
                <Label
                  title={getI18n(
                    'allOrders.orderDetail.refund_components_returndetails_return_uploadimg_formitem_rules_label',
                  )}
                />
              }>
              <RenderUploader disabled={disabledTop} />
            </Form.Item>
          </div>
          {status &&
            status !== EOrderReturnsStatus.ReturnConfirmed &&
            status !== EOrderReturnsStatus.Requested && (
              <h3 className={css.title}>Request Details</h3>
            )}
          {status &&
            status !== EOrderReturnsStatus.ReturnConfirmed &&
            status !== EOrderReturnsStatus.Requested && (
              <div className={css.packageDetails}>
                <div className={css.packageInfo}>
                  <Form.Item
                    name='courier'
                    rules={[
                      {
                        required: true,
                        message: getI18n(
                          'allOrders.orderDetail.refund_components_returndetails_return_courier_formitem_rules_rules_msg',
                        ),
                      },
                    ]}
                    labelCol={{ span: 24 }}
                    className={css.formItem}
                    label={
                      <Label
                        title={getI18n(
                          'allOrders.orderDetail.refund_components_returndetails_return_courier_formitem_rules_rules_label',
                        )}
                      />
                    }>
                    <Input disabled={viewDetail} size='large' />
                  </Form.Item>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    name='waybillNo'
                    rules={[
                      {
                        required: true,
                        message: getI18n(
                          'allOrders.orderDetail.refund_components_returndetails_return_waybillNo_formitem_rules_rules_msg',
                        ),
                      },
                    ]}
                    className={css.formItem}
                    label={
                      <Label
                        title={getI18n(
                          'allOrders.orderDetail.refund_components_returndetails_return_waybillNo_formitem_rules_rules_label',
                        )}
                      />
                    }>
                    <Input disabled={viewDetail} size='large' />
                  </Form.Item>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    name='logisticsRemark'
                    rules={[
                      {
                        required: true,
                        message: getI18n(
                          'allOrders.orderDetail.refund_components_returndetails_return_logisticsRemark_formitem_rules_rules_msg',
                        ),
                      },
                    ]}
                    className={css.formItem}
                    label={
                      <Label
                        title={getI18n(
                          'allOrders.orderDetail.refund_components_returndetails_return_logisticsRemark_formitem_rules_rules_label',
                        )}
                      />
                    }>
                    <Input disabled={viewDetail} size='large' />
                  </Form.Item>
                </div>
                <Form.Item
                  labelCol={{ span: 24 }}
                  name='logisticsImage'
                  className={css.returnForm}
                  label={
                    <Label
                      title={getI18n(
                        'allOrders.orderDetail.refund_components_returndetails_return_logisticsImage_formitem_rules_rules_msg',
                      )}
                    />
                  }>
                  <RenderUploader disabled={viewDetail} />
                </Form.Item>
              </div>
            )}
        </Form>
        <Configuration
          hideRarePart
          configStart={getI18n(
            'allOrders.orderDetail.refund_components_returndetails_return_configuration',
          )}
        />
      </div>
      <ModalFooter
        hideOkButton={!selectedRowKeys.length}
        front={`${selectedRowKeys.length} ${getI18n(
          'allOrders.orderDetail.refund_components_returndetails_return_modalfooter',
        )}`}
        {...(!viewDetail ? { onOk: () => form.submit() } : {})}
        onCancel={onModalCancel}
        okText='Confirm'
      />
    </Fragment>
  );
};

export default ReturnDetails;
